import React, { useRef, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const CardMobile = ({ style, link, videoSrc, title, description, ...props }) => {
  const cardRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(cardRef.current);
        }
      },
      {
        threshold: 0.1,
      }
    );

    if (cardRef.current) {
      observer.observe(cardRef.current);
    }

    return () => {
      // if (cardRef.current) {
      //   observer.unobserve(cardRef.current);
      // }
    };
  }, []);

  return (
    <Link to={link} target="_blank">
      <div className="card fix-card1" ref={cardRef}
      style={{
        ...style,
        opacity: isVisible ? 1 : 0,
        transition: 'opacity 2.5s ease-in-out',
      }}
      {...props}>
        <video 
          src={videoSrc} 
          width="100%" 
          height="100%" 
          autoPlay 
          loop 
          muted 
          playsInline 
        />
        <div className="card-info"> 
          <p className="card-title">{title}</p>
          <p className="card-description">{description}</p>
        </div>
      </div>
    </Link>
  );
};

export default CardMobile;
